import { useCallback } from 'react';

import { Search, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import { useModal } from '@/components/providers/ModalProvider/ModalProvider';
import { Button } from '@/components/shadcn/button';
import SelectParty from '@/features/party/components/SelectParty/SelectParty';
import type { Party } from '@/features/party/types';

import PartySearchModal from '../PartySearchModal';

export default function MultipleParties() {
  const { t } = useTranslation();
  const { showModal } = useModal();

  const { party, linkParty } = useEmail();

  const handleSelectParty = useCallback(
    (party: Party) => linkParty(party.id),
    [linkParty],
  );

  const handleShowPartySearch = useCallback(() => {
    showModal(
      PartySearchModal,
      {
        onSubmit: linkParty,
      },
      {
        title: t('SIDEBAR_PARTY_SEARCH'),
        size: 'full',
      },
    );
  }, [linkParty, showModal, t]);

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="text-foreground flex items-center gap-1.5 text-sm">
          <Users className="size-3.5" />

          {t('PARTY_MULTIPLE_FOUND_TITLE')}
        </div>

        <Button
          variant="secondary"
          size="icon-sm"
          onClick={handleShowPartySearch}
        >
          <Search />
        </Button>
      </div>

      <div className="flex flex-col gap-2">
        <p className="text-muted-foreground text-xs">
          {t('PARTY_SEARCH_SELECT_PROMPT')}
        </p>

        <div className="max-h-34 overflow-y-scroll">
          <SelectParty parties={party.parties} onSubmit={handleSelectParty} />
        </div>
      </div>
    </div>
  );
}
